@if (state && state.indices && state.indices[0]; as index) {
  @for (index of state?.indices; track index) {
    <div class="hits-products">
      <div class="title">
        <h4>
          {{ 'common.products' | translate }}
        </h4>
        <div class="hits stretch">{{ index.results.nbHits >= 100 ? '99+' : index.results.nbHits }}</div>
      </div>
      <div class="results-container">
        @for (product of index.hits | transformProductHit; track product; let i = $index) {
          <app-search-result
            [product]="product"
            (resultClicked)="resultClick(product, i)"
          ></app-search-result>
        }
      </div>
    </div>
  }
} @else {
  <app-page-spinner></app-page-spinner>
}

